import React, { useState } from "react";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  BRAND_COLORS,
  brandFilledButtonSx,
  brandRgba,
} from "../../utils/brandAssets";
import { SHOWCASE_CARDS } from "../../utils/triviaShareCardLab";
import {
  isCollectibleTeaserDismissed,
  writeCollectibleTeaserDismissed,
} from "../../utils/triviaCollectibleTeaserStorage";
import TriviaShareCardScene from "./TriviaShareCardScene";

const TriviaCollectibleTeaser = ({ onPlayDaily, storage }) => {
  const [dismissed, setDismissed] = useState(() =>
    isCollectibleTeaserDismissed(storage)
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    writeCollectibleTeaserDismissed(storage);
    setDismissed(true);
  };

  return (
    <Paper
      sx={{
        position: "relative",
        mb: 3,
        p: { xs: 2, md: 3 },
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "minmax(200px, 240px) 1fr" },
        gap: 2,
        alignItems: "center",
        bgcolor: "#001820",
        border: `1px solid ${brandRgba(BRAND_COLORS.cyan, 0.16)}`,
      }}
    >
      <IconButton
        aria-label="Dismiss collectible teaser"
        onClick={handleDismiss}
        size="small"
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 1,
          color: brandRgba(BRAND_COLORS.cyan, 0.85),
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <TriviaShareCardScene card={SHOWCASE_CARDS.gold} width="min(240px, 70vw)" />
      <Box sx={{ pr: 4 }}>
        <Typography variant="overline" sx={{ color: BRAND_COLORS.cyan, letterSpacing: 1.4 }}>
          Collectible
        </Typography>
        <Typography variant="h5" fontWeight={800} sx={{ mb: 1 }}>
          Your score becomes a card
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Drag it. Flip it. Share it. Daily games stay teal — a perfect board
          unlocks gold foil.
        </Typography>
        {onPlayDaily ? (
          <Button variant="contained" onClick={onPlayDaily} sx={brandFilledButtonSx}>
            Play today&apos;s Daily
          </Button>
        ) : null}
      </Box>
    </Paper>
  );
};

export default TriviaCollectibleTeaser;
